import { render } from "./management.cattle.io.fleetworkspace.vue?vue&type=template&id=00669bee"
import script from "./management.cattle.io.fleetworkspace.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.fleetworkspace.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__